import { catalog } from 'api';
import {
  GET_PARTNERS,
  UPDATE_PARTNERS,
  FETCH_CAMPAIGNS_BY_PARTNER_ID_SHOWROOM_CATALOG,
  UPDATE_CAMPAIGNS_BY_PARTNER_ID_SHOWROOM_CATALOG,
  UPDATE_SHOWROOM_CAMPAIGN_SELECTED,
  UPDATE_CAMPAIGN_SELECTED
} from 'store/actions/catalog';
import { paginationData } from 'helpers/store';
import { userPartnerId } from 'helpers/user';

export default {
  [GET_PARTNERS]: ({ commit }) =>
    new Promise((resolve, reject) => {
      catalog.fetch().then(
        resp => {
          const data = resp.data || [];
          commit(UPDATE_PARTNERS, data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [FETCH_CAMPAIGNS_BY_PARTNER_ID_SHOWROOM_CATALOG]: (
    { commit },
    { partnerId, pagination, filters }
  ) =>
    new Promise(async (resolve, reject) => {
      const id = partnerId || (await userPartnerId());
      catalog.campaignsByPartnerIdFromCatalog({ partnerId: id, pagination, filters }).then(
        resp => {
          const data = resp.data || [];
          commit(UPDATE_CAMPAIGNS_BY_PARTNER_ID_SHOWROOM_CATALOG, data);
          resolve(paginationData(resp).total);
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),
  [UPDATE_SHOWROOM_CAMPAIGN_SELECTED]: ({ commit }, data) => commit(UPDATE_CAMPAIGN_SELECTED, data)
};
